/* PDP in-page navigation: smooth-scrolls to on-page anchors (the sub-nav
   links, and the review-count badge near the title) using the REAL scroll
   container, plus scroll-spy highlighting of the current sub-nav section.

   THE SCROLL CONTAINER IS NOT ALWAYS THE WINDOW.
   At >=990px Horizon's assets/base.css does:

     html:has(.page-wrapper), html:has(.page-wrapper) body { height:100dvh; overflow:hidden; }
     .page-wrapper { height:100dvh; overflow-y:auto; }

   so .page-wrapper is the real scroller, not document/window (see
   assets/scroll-container.js and the note atop assets/ref-brand.js).

   The previous version of this file computed `window.scrollY` and called
   `window.scrollTo(...)`. On the >=990px layout that scrolls the (visually
   clipped, scrollbar-less) document element itself instead of .page-wrapper:
   everything inside .page-wrapper stays exactly where it was while the
   hidden document silently scrolls internally, so the page renders blank
   with no wheel/touch affordance to recover - only a reload fixes it. That
   is the reported bug. Fixed by scrolling the actual container returned by
   scrollTarget(), which mirrors getScrollContainer() in scroll-container.js -
   keep both in sync if Horizon changes its breakpoint. */
(function () {
  'use strict';

  var SQUEEZE = window.matchMedia('(min-width: 990px)');
  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function scrollTarget() {
    if (SQUEEZE.matches) {
      return document.querySelector('.page-wrapper') || document.scrollingElement || document.documentElement;
    }
    return document.scrollingElement || document.documentElement;
  }

  function scrollTopOf(target) {
    if (target && target !== document && typeof target.scrollTop === 'number') return target.scrollTop;
    return window.scrollY || document.documentElement.scrollTop || 0;
  }

  var nav = document.querySelector('.pdp-nav');

  function offset() {
    return nav ? nav.getBoundingClientRect().height + 8 : 16;
  }

  // Scoped to the document, not just the sub-nav: the review-count badge
  // near the title also uses data-pdp-nav to jump to #reviews, and some
  // tiers (e.g. accessory) render no sticky sub-nav at all.
  var links = Array.prototype.slice.call(document.querySelectorAll('[data-pdp-nav]'));

  links.forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href').slice(1);
      var el = document.getElementById(id);
      if (!el) return;
      e.preventDefault();

      var target = scrollTarget();
      var elTop = el.getBoundingClientRect().top;
      var containerTop = (target === document || target === document.documentElement)
        ? 0
        : target.getBoundingClientRect().top;
      var y = elTop - containerTop + scrollTopOf(target) - offset();

      target.scrollTo({ top: y, behavior: REDUCE ? 'auto' : 'smooth' });
    });
  });

  if (nav && 'IntersectionObserver' in window) {
    var navLinks = Array.prototype.slice.call(nav.querySelectorAll('[data-pdp-nav]'));
    var targets = navLinks.map(function (a) {
      var id = a.getAttribute('href').slice(1);
      return { link: a, el: document.getElementById(id) };
    }).filter(function (t) { return t.el; });

    // Root must match the real scroll container or IntersectionObserver
    // never fires on the >=990px layout - mirrors getIntersectionRoot() in
    // scroll-container.js.
    var root = SQUEEZE.matches ? (document.querySelector('.page-wrapper') || null) : null;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        targets.forEach(function (t) { t.link.classList.toggle('is-current', t.el === en.target); });
      });
    }, { root: root, rootMargin: '-30% 0px -60% 0px', threshold: 0 });
    targets.forEach(function (t) { io.observe(t.el); });
  }
})();
